// extracted by mini-css-extract-plugin
var _1 = "Mask_icon__50bc4";
var _2 = "Mask_mask__83c30";
export { _1 as "icon", _2 as "mask" }
